import { render, staticRenderFns } from "./UsdtBankData.vue?vue&type=template&id=451f51a6&scoped=true&"
import script from "./UsdtBankData.vue?vue&type=script&lang=ts&"
export * from "./UsdtBankData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f51a6",
  null
  
)

export default component.exports